import React from 'react';
import { MdMoreHoriz } from 'react-icons/md';

import { IconButton } from '@material-ui/core';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';

import { Container, MaterialMenu } from './styles';

const Menu: React.FC = ({ children }) => {
  return (
    <Container>
      <PopupState variant="popover" popupId="long-menu">
        {(popupState) => (
          <>
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              {...bindTrigger(popupState)}
            >
              <MdMoreHoriz size={24} />
            </IconButton>
            <MaterialMenu
              id="long-menu"
              keepMounted
              {...bindMenu(popupState)}
              onClick={popupState.close}
            >
              {children}
            </MaterialMenu>
          </>
        )}
      </PopupState>
    </Container>
  );
};

export default Menu;
